import { TimeChallengeComponent } from './admin/challenge/time-challenge/time-challenge.component';
import { ReportsComponent } from './admin/reports/reports.component';
import { RegisterComponent } from './auth/register/register.component';
import { PaypalButtonComponent } from './auth/register/paypal-button/paypal-button.component';
import { PaymentRejectedComponent } from './auth/payment-rejected/payment-rejected.component';
import { AdminResetPasswordComponent } from './admin/administrator/admin-reset-password/admin-reset-password.component';
import { NutriResetPasswordComponent } from './nutritionist/nutri/nutri-reset-password/nutri-reset-password.component';
import { UpgradePlanComponent } from './auth/upgrade-plan/upgrade-plan.component';
import { NutriProfileComponent } from './nutritionist/nutri/nutri-profile/nutri-profile.component';
import { NutriComponent } from './nutritionist/nutri/nutri.component';
import { CustomerListComponent } from './nutritionist/customer-list/customer-list.component';
import { ResetPswComponent } from './auth/reset-psw/reset-psw.component';
import { AuthGuard } from './services/auth.guard';
import { ChallengeComponent } from './admin/challenge/challenge.component';
import { AdminNotificationsComponent } from './admin/admin-notifications/admin-notifications.component';
import { AdminProfileComponent } from './admin/administrator/admin-profile/admin-profile.component';
import { AdministratorComponent } from './admin/administrator/administrator.component';
import { NutritionComponent } from './admin/nutrition/nutrition.component';
import { HomeComponent } from './main/home/home.component';
import { WorkoutComponent } from './admin/workout/workout.component';
import { ProgramComponent } from './admin/program/program.component';
import { ExerciseComponent } from './admin/exercise/exercise.component';
import { PromotionsComponent } from './admin/promotion/promotions.component';
import { SubscriptionComponent } from './admin/subscription/subscription.component';
import { UserComponent } from './admin/user/user.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomLayoutComponent } from './custom-layout/custom-layout.component';
import { ConsoleComponent } from "./admin/console/console.component";
import { AppSelectionModalComponent } from './auth/register/app-selection-modal/app-selection-modal.component';
import { RegisterConfirmComponent } from './auth/register-confirm/register-confirm.component';
import { CategorieComponent } from './admin/categorie/categorie.component';
import { AssignOndemandComponent } from './admin/assign-ondemand/assign-ondemand.component';
import { RenewPlanComponent } from './auth/renew-plan/renew-plan.component';
import { RecipesComponent } from './admin/recipes/recipes.component';
import { BannerAreaComponent } from './admin/banner-area/banner-area.component';
import { ThropiesComponent } from './admin/thropies/thropies.component';
import { StreamEventComponent } from './admin/stream-event/stream-event.component';
import { RegisterConfirmMobileComponent } from './auth/register-confirm-mobile/register-confirm-mobile.component';
import { ChangeWeekComponent } from './main/home/change-week/change-week.component';
import { WorkoutProgramsComponent } from './main/home/workout-programs/workout-programs.component';
import { WorkoutDetailComponent } from './main/workout/workout-detail/workout-detail.component';
import { WorkoutExecutionComponent } from './main/workout/workout-execution/workout-execution.component';
import { WorkoutCompletedComponent } from './main/workout/workout-execution/workout-completed/workout-completed.component';
import { InfoComponent } from './main/info/info.component';
import { FacebookComponent } from './main/facebook/facebook.component';
import { OnDemandComponent } from './main/on-demand/on-demand.component';
import { OnDemandCategoryComponent } from './main/on-demand/on-demand-category/on-demand-category.component';
import { OnDemandVideoComponent } from './main/on-demand/on-demand-category/on-demand-video/on-demand-video.component';
import { TimeChallengeVideoComponent } from './main/on-demand/time-challenge-user/time-challenge-video/time-challenge-video.component';
import { NotificationsComponent } from './main/notifications/notifications.component';
import { UserProfileComponent } from './main/user/user-profile.component';
import { ProfileComponent } from './main/user/profile/profile.component';
import { SubComponent } from './main/user/sub/sub.component';
import { ResetPasswordComponent } from './main/user/reset-password/reset-password.component';
import { DiaryComponent } from './main/diary/diary.component';
import { WorkoutHistoryComponent } from './main/diary/workout-history/workout-history.component';
import { FavoriteWorkoutsComponent } from './main/diary/favorite-workouts/favorite-workouts.component';
import { ExerciseTrackerComponent } from './main/diary/exercise-tracker/exercise-tracker.component';
import { ThropiesUserComponent } from './main/diary/thropies-user/thropies-user.component';
import { LiveStreamingComponent } from './main/live-streaming/live-streaming.component';
import { WorkoutDetailFavoriteComponent } from './main/diary/favorite-workouts/workout-detail-favorite/workout-detail-favorite.component';
import { WorkoutExecutionFavoriteComponent } from './main/diary/favorite-workouts/workout-execution-favorite/workout-execution-favorite.component';
import { NutritionUserComponent } from './main/nutrition-user/nutrition-user.component';
import { CompileSurveyComponent } from './main/nutrition-user/compile-survey/compile-survey.component';
import { MealPlanComponent } from './main/nutrition-user/meal-plan/meal-plan.component';
import { QuizSelectProgramComponent } from './auth/login/quiz-select-program/quiz-select-program.component';
import { FullViewDietComponent } from './admin/nutrition/nutrition-detail/compose-diet/full-view-diet/full-view-diet.component';
import { AddonsComponent } from './admin/addons/addons.component';
import { UserAddonsComponent } from './main/user-addons/user-addons.component';
import { UserAddonDetailComponent } from './main/user-addons/user-addon-detail/user-addon-detail.component';
import { AddonPurchaseHistoryComponent } from './main/addon-purchase-history/addon-purchase-history.component';
import { DownloadEbookComponent } from './auth/download-ebook/download-ebook.component';

const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'prefix' },
  {
    path: 'auth',
    children: [
      {
        path: 'welcome',
        loadChildren: () => import('./welcome/welcome.module').then(m => m.WelcomeModule),
      },
      {
        path: 'login',
        loadChildren: () => import('./auth/login/login.module').then(m => m.LoginModule)
      },
      {
        path: 'login/:redirectto',
        loadChildren: () => import('./auth/login/login.module').then(m => m.LoginModule)
      },
      {
        path: 'register/:device',
        component: RegisterComponent
      },
      {
        path: 'forgot-password',
        loadChildren: () => import('./auth/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
      },
      {
        path: 'users/reset/:email/:token',
        component: ResetPswComponent
      },
      {
        path: 'upgrade-plan',
        component: UpgradePlanComponent
      },
      {
        path: 'payment-rejected',
        component: PaymentRejectedComponent
      },
      {
        path: 'register-confirm',
        component: RegisterConfirmComponent
      },
      {
        path: 'register-confirm-mobile',
        component: RegisterConfirmMobileComponent
      },
      {
        path: 'application',
        component: AppSelectionModalComponent
      },
      {
        path: 'renew-plan',
        component: RenewPlanComponent
      },
      {
        path: 'quiz-select-program',
        component: QuizSelectProgramComponent
      },
      {
        path:'diet-summary',
        component: FullViewDietComponent
      },
      {
        path: 'download-ebook',
        component: DownloadEbookComponent
      },
      { path: '', redirectTo: 'login', pathMatch: 'prefix' },
    ]
  },
  {
    path: 'admin',
    component: CustomLayoutComponent,
    children: [
      {
        path: 'administrator',
        component: AdministratorComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: 'admin-profile',
            component: AdminProfileComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'admin-reset-password',
            component: AdminResetPasswordComponent,
            canActivate: [AuthGuard],
          },
          { path: '', redirectTo: 'admin-profile', pathMatch: 'full' }
        ]
      },
      {
        path: 'recipes',
        component: RecipesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'banner',
        component: BannerAreaComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'trophies',
        component: ThropiesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'streaming_event',
        component: StreamEventComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'console',
        component: ConsoleComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'user',
        component: UserComponent,
        canActivate: [AuthGuard],
        loadChildren: () => import('./admin/user/user.module').then(m => m.UserModule),
      },
      {
        path: 'subs',
        component: SubscriptionComponent,
        canActivate: [AuthGuard],
        loadChildren: () => import('./admin/subscription/subscription.module').then(m => m.SubscriptionModule),
      },
      {
        path: 'promotion',
        component: PromotionsComponent,
        canActivate: [AuthGuard],
        loadChildren: () => import('./admin/promotion/promotions.module').then(m => m.PromotionsModule),
      },
      {
        path: 'exercise',
        component: ExerciseComponent,
        canActivate: [AuthGuard],
        loadChildren: () => import('./admin/exercise/exercise.module').then(m => m.ExerciseModule),
      },
      {
        path: 'program',
        component: ProgramComponent,
        canActivate: [AuthGuard],
        loadChildren: () => import('./admin/program/program.module').then(m => m.ProgramModule),
      },
      {
        path: 'workout',
        component: WorkoutComponent,
        canActivate: [AuthGuard],
        loadChildren: () => import('./admin/workout/workout.module').then(m => m.WorkoutModule),
      },
      {
        path: 'nutrition',
        canActivate: [AuthGuard],
        component: NutritionComponent,
      },
      {
        path: 'admin-notifications',
        canActivate: [AuthGuard],
        component: AdminNotificationsComponent,
      },
      {
        path: 'challenge',
        canActivate: [AuthGuard],
        component: ChallengeComponent,
      },
      {
        path: 'time-challenge',
        canActivate: [AuthGuard],
        component: TimeChallengeComponent,
      },
      {
        path: 'reports',
        canActivate: [AuthGuard],
        component: ReportsComponent,
      },
      {
        path: 'categories',
        canActivate: [AuthGuard],
        component: CategorieComponent,
      },
      {
        path: 'assign-ondemand',
        canActivate: [AuthGuard],
        component: AssignOndemandComponent,
      },
      {
        path: 'addons',
        canActivate: [AuthGuard],
        component: AddonsComponent
      },
      { path: '', redirectTo: 'console', pathMatch: 'full' }
    ]
  },
  {
    path: 'nutritionist',
    component: CustomLayoutComponent,
    children: [
      {
        path:'customer',
        component: CustomerListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'recipes',
        component: RecipesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'nutri',
        component: NutriComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: 'nutri-profile',
            component: NutriProfileComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'nutri-reset-password',
            component: NutriResetPasswordComponent,
            canActivate: [AuthGuard],
          },
          { path: '', redirectTo: 'nutri-profile', pathMatch: 'full' }
        ]
      },
      { path: '', redirectTo: 'customer', pathMatch: 'full' }
    ]
  },
  {
    path: 'main',
    component: CustomLayoutComponent,
    children: [
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuard],
        loadChildren: () => import('./main/home/home.module').then(m => m.HomeModule),
      },
      {
        path: 'change-week',
        component: ChangeWeekComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'workout-programs',
        component: WorkoutProgramsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'workout-detail',
        canActivate: [AuthGuard],
        component: WorkoutDetailComponent
      },
      {
        path: 'workout-execution',
        canActivate: [AuthGuard],
        component: WorkoutExecutionComponent
      },
      {
        path: 'workout-completed',
        canActivate: [AuthGuard],
        component: WorkoutCompletedComponent
      },
      {
        path: 'info',
        canActivate: [AuthGuard],
        component: InfoComponent
      },
      {
        path: 'facebook',
        canActivate: [AuthGuard],
        component: FacebookComponent
      },
      {
        path: 'on-demand',
        canActivate: [AuthGuard],
        component: OnDemandComponent
      },
      {
        path: 'on-demand/:tab',
        canActivate: [AuthGuard],
        component: OnDemandComponent
      },
      {
        path: 'ondemand-category',
        canActivate: [AuthGuard],
        component: OnDemandCategoryComponent
      },
      {
        path: 'ondemand-video',
        canActivate: [AuthGuard],
        component: OnDemandVideoComponent
      },
      {
        path: 'timechallenge-video',
        canActivate: [AuthGuard],
        component: TimeChallengeVideoComponent
      },
      {
        path: 'notifications',
        canActivate: [AuthGuard],
        component: NotificationsComponent
      },
      {
        path: 'user',
        component: UserProfileComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: 'profile',
            component: ProfileComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'sub',
            component: SubComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'reset-password',
            component: ResetPasswordComponent,
            canActivate: [AuthGuard],
          },
          { path: '', redirectTo: 'profile', pathMatch: 'full' }
        ]
      },
      {
        path: 'diary',
        canActivate: [AuthGuard],
        component: DiaryComponent
      },
      {
        path: 'workout-history',
        canActivate: [AuthGuard],
        component: WorkoutHistoryComponent
      },
      {
        path: 'trophies',
        canActivate: [AuthGuard],
        component: ThropiesUserComponent
      },
      {
        path: 'favorite-workouts',
        canActivate: [AuthGuard],
        component: FavoriteWorkoutsComponent
      },
      {
        path: 'exercise-tracker',
        canActivate: [AuthGuard],
        component: ExerciseTrackerComponent
      },
      {
        path: 'streaming',
        canActivate: [AuthGuard],
        component: LiveStreamingComponent
      },
      {
        path: 'workout-detail-favorite',
        canActivate: [AuthGuard],
        component: WorkoutDetailFavoriteComponent
      },
      {
        path: 'workout-execution-favorite',
        canActivate: [AuthGuard],
        component: WorkoutExecutionFavoriteComponent
      },
      {
        path: 'user-nutrition',
        canActivate: [AuthGuard],
        component: NutritionUserComponent
      },
      {
        path: 'compile-survey',
        canActivate: [AuthGuard],
        component: CompileSurveyComponent
      },
      {
        path: 'meal-plan',
        canActivate: [AuthGuard],
        component: MealPlanComponent
      },
      {
        path: 'addons',
        canActivate: [AuthGuard],
        component: UserAddonsComponent
      },
      {
        path: 'addon-detail',
        canActivate: [AuthGuard],
        component: UserAddonDetailComponent
      },
      {
        path: 'addon-purchase-history',
        canActivate: [AuthGuard],
        component: AddonPurchaseHistoryComponent
      },
      {
        path: 'refresh',
        component: HomeComponent,
        canActivate: [AuthGuard],
        loadChildren: () => import('./main/home/home.module').then(m => m.HomeModule),
      },
      { path: '', redirectTo: 'home', pathMatch: 'full' }
    ]
  },


];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // preloadingStrategy: PreloadAllModules,
    useHash: true,
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'corrected',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
